import { SvgCheck } from '@common/icon';
import { cn } from '@core/utils';

import { Image } from '@/components/client';

import { PRIZE_DATA } from '../../constants';

type PrizeCardContentProps = {
  regions: 2 | 5 | 7 | 10;
  isCompleted?: boolean;
};

export const PrizeCardContent = ({
  regions,
  isCompleted = false,
}: PrizeCardContentProps) => {
  const data = PRIZE_DATA[regions];
  const displayLabel = isCompleted ? data.completedLabel : data.label;

  return (
    <>
      <div className="relative z-[1] flex flex-col gap-8 p-20">
        <div
          className={cn(
            'inline-flex items-center justify-center gap-4 self-start rounded-xsmall px-8 py-4',
            isCompleted ? 'bg-Gray-white' : 'border border-solid border-O-500',
          )}
        >
          <span
            className={cn(
              'whitespace-nowrap text-center font-800 text-O-500 typo-body4',
            )}
          >
            {displayLabel}
          </span>
          {isCompleted && <SvgCheck className="size-14 text-O-500" />}
        </div>

        <p
          className={cn(
            'whitespace-pre-line font-800 typo-body2',
            isCompleted ? 'text-Gray-white' : 'text-Gray-black',
            '!leading-[1.2]',
          )}
        >
          {data.prize}
          {'prizeDetail' in data && (
            <span className="ml-4 typo-body4">{data.prizeDetail}</span>
          )}
        </p>
      </div>

      <div
        className="absolute inset-y-0 right-14 min-w-143"
        aria-hidden="true"
      >
        <Image
          src={data.image.url}
          alt={`${data.label} 경품 이미지`}
          width={data.image.width}
          height={data.image.height}
          className="size-full object-contain object-bottom"
          quality={85}
          loading="lazy"
        />
      </div>
    </>
  );
};
